import { Col, Row, Spinner } from "reactstrap";

import Breadcrumbs from "@components/ui-components/breadcrumbs";
import Card from "@components/ui-components/card";
import ChurnOver from "./widgets/churn-over";
import DateRangePicker from "@components/fields/date-picker/range-picker";
import Flex from "@components/ui-components/flex";
import { LAST_30_DAYS_DATE } from "@src/utility/constants";
import MrrGraph from "./widgets/mrr";
import OnboardingWon from "./widgets/onboarding-won";
import TopCompanies from "./widgets/top-companies";
import UpsellOver from "./widgets/upsell-over";
import { t } from "i18next";
import useDashboard from "./use-dashboard";
import useDateHandler from "@hooks/use-date-handler";

const Dashboard = () => {
    const { data: dashboardData, getDashboardData, loading } = useDashboard();

    const { control, handleDateChange } = useDateHandler({
        onSubmit       : getDashboardData,
        defaultValues  : LAST_30_DAYS_DATE,
        defaultHandling: true
    });

    return (
        <>
            <Breadcrumbs
                items={[
                    {
                        title : "Dashboard",
                        active: true
                    }
                ]}
                rightChildren={
                    <Flex align="center">
                        <DateRangePicker
                            control={control}
                            customOnChange={handleDateChange}
                            maxDate={new Date()}
                            id="date"
                            name="date"/>
                    </Flex>
                }/>

            {/* Stats Cards */}
            <Row>
                {[...Array(3)].map((_, index) => {
                    const stat = dashboardData.stats[index];
                    return (
                        <Col md={4} key={index}>
                            <Card containerClass="bg-light-primary">
                                {loading ? (
                                    <Spinner type="grow" size="sm" />
                                ) : (
                                    <>
                                        <h6 className="text-muted">
                                            {stat?.title}
                                        </h6>
                                        <h2 className="text-primary">
                                            {stat?.value}
                                        </h2>
                                    </>
                                )}
                            </Card>
                        </Col>
                    );
                })}
            </Row>

            <Row>
                <Col md={5}>
                    <TopCompanies
                        id="companies-by-stage"
                        loading={loading}
                        title={t("Top Companies Based on stages")}
                        series={dashboardData.companiesByStage.series}
                        height={500}/>
                </Col>
                <Col md={7}>
                    <OnboardingWon
                        id="onboarding-won-graph"
                        loading={loading}
                        title={t("On boarding Won graph")}
                        categories={dashboardData.onBoardingWon.categories}
                        series={dashboardData.onBoardingWon.series}
                        height={500}/>
                </Col>
                <Col md={12}>
                    <MrrGraph
                        id="mrr-graph"
                        loading={loading}
                        title={t("MRR graph over period")}
                        categories={dashboardData.mrrGraph.categories}
                        series={dashboardData.mrrGraph.series}/>
                </Col>
                <Col md={12}>
                    <UpsellOver
                        id="upsell-over-period"
                        loading={loading}
                        title={t("Change in upsell over period")}
                        categories={dashboardData.upsellOverPeriod.categories}
                        series={dashboardData.upsellOverPeriod.series}
                        height={350}/>
                </Col>
                <Col md={12}>
                    <ChurnOver
                        id="churn-over-period"
                        loading={loading}
                        title={t("Change in churn over period")}
                        categories={dashboardData.churnOverPeriod.categories}
                        series={dashboardData.churnOverPeriod.series}
                        height={350}/>
                </Col>
            </Row>

        </>
    );
};

export default Dashboard;
